import ContribuicaoForm from "../components/ContribuicaoForm";

export default function EventoContribuicaoForm() {
  return <ContribuicaoForm rotaVisualizar="/evento/visualizar" />;
}
